import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Form from '../../components/Fields/Form';
import { HorizontalTabs } from '../../components/Tabs/HorizontalTabs';
import ExportHub_tab_ExportBrands from './Tabs/ExportHub_tab_ExportBrands';

const ExportHub: React.FC = () => {

    return (
        <div className='main-content'>
            <Form title='Export hub' >
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <HorizontalTabs
                                id='vtabs'
                                defaultActiveKey='brands'
                                tabs={[
                                    {
                                        title: 'Brands',
                                        eventKey: 'brands',
                                        component: <ExportHub_tab_ExportBrands />,
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                </Container>
            </Form>
        </div>
    );
}
export default ExportHub;